module.exports = __webpack_public_path__ + "img/terminos_y_condiciones-02.96bbb3e5.png";